import { AppState, InitialAppState } from './app.state';
import { AppAction } from './app.action';

export function rootReducer(state: AppState = new InitialAppState(), action: AppAction): AppState {
    switch (action.type) {
        default:
            return state;
    }
}
